import { API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";

class BookingService {

  static buySubscriptionsPlan(payload) {
    const api = API_PATHS.buyPlan;

    return axiosInstance.post(api, payload);
  }


  static activateFreeSubscription(payload) {
    const api = API_PATHS.activateFreeSubscription;

    return axiosInstance.post(api, payload);
  }


  static verifyPayment(payload) {
    const api = API_PATHS.storePayment;

    return axiosInstance.post(api, payload);
  }

  static getPurchaseSubscription() {
    const api = API_PATHS.getBooking;

    return axiosInstance.get(api);
  }


}

export default BookingService;
